var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper p-0"},[_c('div',{staticClass:"content"},[_vm._m(0),_c('AiAssistantSettings',{key:_vm.clinicUrl,attrs:{"clinic-url":_vm.clinicUrl}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"mb-3"},[_c('i',{staticClass:"fas fa-robot mr-2"}),_vm._v("AI Assistant")])
}]

export { render, staticRenderFns }